import { Store } from '@ngrx/store';
import { IController } from 'angular';
import * as _ from 'lodash';
import { CREDIT_REQS } from '../../../../../ng2/shared/constants/credit-reqs.constant';
import { CreditRequirements } from '../../../../../ng2/shared/constants/credit-requirements.constant';
import { ChangeMadeInMetrics, ChangeSavedInMetrics } from '../../../../../ng2/store/actions/metrics-actions';

export class CreditMetricsTableCtrl implements IController {
  static $inject: string[] = ['$mdDialog', '$mdEditDialog', '$scope', 'Store'];

  // bindings
  private changeMadeInMetrics: { status: boolean };
  private creditTableCopy: Array<{ [key: string]: number }>;
  public cohort: Array<{ [key: string]: number }>;

  constructor(private $mdDialog, private $mdEditDialog, private $scope, private store: Store<any>) {}

  public getTermsPerYear(): number {
    return this.cohort ? this.cohort.length / 4 : 0;
  }

  public getClassKeys() {
    let classKeys = _.keys(this.cohort[0]);
    classKeys = _.without(classKeys, 'term');
    classKeys = _.sortBy(classKeys, key => {
      const gradReq = _.find(CreditRequirements, { camelCase: key });
      return gradReq ? gradReq.orders.creditPanel : null;
    });

    return classKeys;
  }

  public classKeyToHumanName(classKey): string {
    const gradReq = _.find(CreditRequirements, { camelCase: classKey });
    return gradReq ? gradReq.human : null;
  }

  public getTermIndexes(): number[] {
    let ret = [];
    for (let i = 0; i < this.cohort.length; i++) {
      ret.push(i);
    }
    return ret;
  }

  public validationErrorForClassKey(classKey): boolean {
    let rowValues = []; // values of evt row
    let validationErrors = false;
    let gradeReqTemp: any = _.get(CREDIT_REQS, classKey);
    let gradReq = gradeReqTemp.gradReq;
    let displayError;

    let errorMessages = {
      gradReqs: 'Final term cannot be less than graduation requirements (' + gradReq + ' credits).',
      sequence: 'Credit requirements must increase sequentially.',
    };

    _.forEach(this.cohort, function(value) {
      rowValues.push(value[classKey]);
    });

    for (let i = 0; i < rowValues.length; i++) {
      if (rowValues[i] > rowValues[i + 1]) {
        validationErrors = true;
        displayError = errorMessages.sequence;
      } else if (rowValues[rowValues.length - 1] < gradReq) {
        validationErrors = true;
        displayError = errorMessages.gradReqs;
      }
    }
    return validationErrors ? displayError : false;
  }

  public editCell(event, termIndex, classKey) {
    let cellValue = this.cohort[termIndex][classKey];
    let originalValue = angular.copy(cellValue);
    this.$mdEditDialog.small({
      modelValue: cellValue,
      targetEvent: event,
      save: (input: { $modelValue: string }) => {
        // any type to reflect input as userInput
        const isValidInput = (input: any) => {
          if (!input.match) return false;
          else return input.match(/^\d*\.?\d+$/);
        };

        this.cohort[termIndex][classKey] = isValidInput(input.$modelValue)
          ? parseFloat(input.$modelValue)
          : originalValue;

        // check diffs and disable the save button if no changes have been made
        const diffs = _.reduce(
          this.cohort,
          (diffExists: boolean, value, idx: number) => {
            const areEqual = _.isEqual(value, this.creditTableCopy[idx]);
            diffExists = areEqual ? diffExists : true;
            return diffExists;
          },
          false,
        );

        this.changeMadeInMetrics.status = diffs ? true : false;

        if (this.changeMadeInMetrics.status) this.store.dispatch(new ChangeMadeInMetrics());
        else this.store.dispatch(new ChangeSavedInMetrics());
      },
    });
  }
}

angular.module('nv.SchoolMetricsModule').controller('CreditMetricsTableCtrl', CreditMetricsTableCtrl);
